import { IconButton, SxProps, Typography } from "@mui/material";
import { FC, ReactElement } from "react";
import { Outlet } from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";

interface IToolTipProps {
  title: string | ReactElement;
  icon?: any;
  children?: ReactElement<any, any>;
  style?: SxProps;
}

const ToolTip: FC<IToolTipProps> = ({ title, icon, children, style }) => {
  return (
    <Tooltip
      title={<Typography sx={style}>{title}</Typography>}
      placement="top-start"
      arrow
    >
      {icon ? (
        <IconButton
          sx={{
            padding: "8px 2px 8px",
            "&:hover": { background: "transparent" },
          }}
        >
          {icon}
        </IconButton>
      ) : (
        children ?? <Outlet />
      )}
    </Tooltip>
  );
};

export default ToolTip;
